import {Avatar, Button, Dropdown, Flex, Image, Layout, MenuProps, Space, Switch, theme, Typography} from "antd"
import {DownOutlined, MoonOutlined, SunOutlined, UserOutlined} from "@ant-design/icons"
import {useContext} from "react"
import {useTranslation} from "react-i18next"
import {Link} from "react-router-dom"
import type {RefineThemedLayoutV2HeaderProps} from "@refinedev/antd"
import {useGetIdentity, useGetLocale, useLogout, useSetLocale, useTranslate} from "@refinedev/core"
import {ColorModeContext} from "./ColorMode"

const {Text, Title} = Typography
const {useToken} = theme

export const Header: React.FC<RefineThemedLayoutV2HeaderProps> = () => {
    const {i18n} = useTranslation()
    const locale = useGetLocale()
    const {data: identity} = useGetIdentity<any>()
    const changeLocale = useSetLocale()
    const {mode, setMode} = useContext(ColorModeContext)
    const translate = useTranslate()
    const {token} = useToken()

    const currentLocale = locale() ?? 'en'
    const langItems: MenuProps["items"] = i18n.languages.map((lang: string) => ({
        key: lang,
        onClick: () => changeLocale(lang),
        icon: <Avatar shape="square" size={16} src={`/images/flags/${lang}.svg`} style={{marginRight: 8}}/>,
        label: translate('lang.' + lang)
    }))
    const actionItems: MenuProps["items"] = [{
        key: 'logout',
        onClick: () => logout(),
        label: translate('buttons.logout')
    }]
    const {mutate: logout} = useLogout();

    return (
        <Layout.Header style={{position: 'sticky', top: 0, backgroundColor: token.colorBgElevated, zIndex: 1}}>
            <Flex align="center" justify="space-between">
                <Link to={'.'}>
                    <Space>
                        <Image preview={false} width={40} src="/images/la.png"/>
                        <Title level={4} style={{margin: 0}}>LAAdmin</Title>
                    </Space>
                </Link>
                <Space>
                    <Switch
                        checkedChildren={<MoonOutlined/>}
                        unCheckedChildren={<SunOutlined/>}
                        onChange={() => setMode()}
                        defaultChecked={mode}
                    />
                    <Dropdown menu={{items: langItems, selectedKeys: [currentLocale]}}>
                        <Button type="text">
                            <Space>
                                <Avatar shape="square" size={16} src={`/images/flags/${currentLocale}.svg`}/>
                                {translate('lang.' + currentLocale)}
                                <DownOutlined/>
                            </Space>
                        </Button>
                    </Dropdown>
                    <Dropdown menu={{items: actionItems}} placement="bottomRight">
                        <Space>
                            <Avatar icon={<UserOutlined/>}/>
                            <Text><strong>{identity?.username}</strong></Text>
                            <DownOutlined/>
                        </Space>
                    </Dropdown>
                </Space>
            </Flex>
        </Layout.Header>
    )
}
